import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Divider from '@mui/material/Divider';
import { useDeviceType } from "src/Utils/useDeviceType";

import { menuCoach } from "../../Utils/menuCoach";
import { menuClient } from "../../Utils/menuClient";
import { menuMember } from "../../Utils/menuMember";
import { customColor } from "src/Data/customColor";
import CalendlyModal from "../CalendlyModal";

import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import logo from "src/Assets/logos/loco_white.png";
import arrowRight from "src/Assets/icons/logout_right.svg";
import arrowLeft from "src/Assets/icons/logout_left.svg";
import iconProfile from "src/Assets/iconography/sidebar_mi_perfil.svg";
import iconGuides from "src/Assets/iconography/sidebar_guias.svg";

function Sidebar({ sidebarCollapsed, setSidebarCollapsed, sidebarOpen, setSidebarOpen }) {

  const [custom, setCustom] = useState(null);
  const session = useSelector((state) => state.session);
  const { isDesktop } = useDeviceType();

  const handleNavClick = () => {
    if (!isDesktop && setSidebarOpen) setSidebarOpen(false);
  };
  const [collapsed, setCollapsed] = useState(false);
  const [calendlyModalOpen, setCalendlyModalOpen] = useState(false);

  const menuList = (session.userType === 'coach') ? menuCoach : session.user?.role === 'client' ? menuClient : menuMember;

  const revealRefs = useRef([]);
  revealRefs.current = [];
  const pathname = window.location.pathname
  const addToRef = (el) => {
    if (el && !revealRefs.current.includes(el)) {
      revealRefs.current.push(el);
    }
  };

  useEffect(() => {
    //Color User
    if (session.user?.colorUI) {
      const color = customColor.find(color => color.id === session.user?.colorUI);
      setCustom(color);
    }

    //Color Coach
    if (session.user?.coach?.colorUI) {
      const color = customColor.find(color => color.id === session.user.coach?.colorUI);
      setCustom(color);
    }
  }, [session.user]);

  return (
    <aside
      className={`${!sidebarOpen ? 'hidden' : ''} fixed z-20 h-full top-0 left-0 flex lg:flex flex-shrink-0 flex-col w-auto transition-width duration-75`}
    >
      <div

        className={`${!custom ? 'bg-gradient-to-r from-blue-secondary to-blue' : ''} relative flex-1 flex flex-col min-h-0 border-r border-gray pt-0`}
        style={{
          backgroundColor: custom ? custom.colors.default : ''
        }}
      >
        <div className="flex-1 flex flex-col pb-4 overflow-y-auto">
          <div
            className={`${!sidebarCollapsed ? "hidden" : ""} flex flex-col items-center justify-center`}
          >
            <div className="flex items-center justify-center w-36 h-24 max-h-24 max-w-36">
              <img
                loading="lazy"
                className="max-h-24"
                src={session.user?.companyPhoto ? session.user?.companyPhoto.fileURL : session.user?.coach?.companyPhoto ? session.user?.coach?.companyPhoto?.fileURL : logo}
              />
            </div>
          </div>
          <Divider
            sx={{
              bgcolor: '#fff',
              marginX: 2
            }}
          />
          <div className="flex-1 pl-1 mt-4">
            <ul className="">
              {menuList.map((element) => {
                return (
                  <Link
                    onFocus={e => e.target.blur()}
                    key={element.title}
                    to={element.link}
                    onClick={handleNavClick}
                    className='flex py-1 tablet:py-2 md:py-3 px-2 mb-1'
                    style={{
                      marginTop: element.link === "/profile" && "60px",
                      display: !sidebarCollapsed ? 'flex' : 'block',
                    }}
                  >
                    <li
                      ref={addToRef}
                      className="flex"
                      style={{ marginRight: sidebarCollapsed && "50px" }}
                    >
                      <img src={element.image} alt="nav" className="w-5 h-5 tablet:w-6 tablet:h-6 md:w-7 md:h-7" />
                      {sidebarCollapsed && (
                        <p
                          className={`${pathname.includes(element.link) && 'text-bold'} ml-3 text-sm tablet:text-lg md:text-xl text-white nav-text`}
                        >{element.title}</p>
                      )}
                    </li>
                  </Link>
                );
              })}
            </ul>

            <Divider
              sx={{
                bgcolor: '#fff',
                marginY: 2,
                marginX: 2
              }}
            />
            <Link
              onFocus={e => e.target.blur()}
              key='Profile'
              to='/profile'
              onClick={handleNavClick}
              className='flex py-1 tablet:py-3 md:py-2 lg:py-3 px-2 mb-1 hover:border-white hover:border-r-4'
              style={{
                marginTop: "10px",
                display: !sidebarCollapsed ? 'flex' : 'block',
              }}
            >
              <li
                ref={addToRef}
                className="flex"
              >
                <img src={iconProfile} alt="nav" className="w-5 h-5 tablet:w-6 tablet:h-6 md:w-7 md:h-7" />
                {sidebarCollapsed && (
                  <p
                    className={`${pathname.includes('/profile') && 'text-bold'} ml-3 text-sm tablet:text-lg md:text-xl text-white nav-text`}
                  > Mi Perfil</p>
                )}
              </li>
            </Link>
            <Link
              onFocus={e => e.target.blur()}
              key='Guides'
              to='/guides'
              onClick={handleNavClick}
              className='flex py-1 tablet:py-3 md:py-2 lg:py-3 px-2 mb-1 hover:border-white hover:border-r-4'
              style={{
                display: !sidebarCollapsed ? 'flex' : 'block',
              }}
            >
              <li
                ref={addToRef}
                className="flex"
                style={{ marginRight: sidebarCollapsed && "50px" }}
              >
                <img src={iconGuides} alt="nav" className="w-5 h-5 tablet:w-6 tablet:h-6 md:w-7 md:h-7" />
                {sidebarCollapsed && (
                  <p
                    className={`${pathname.includes('/guides') && 'text-bold'} ml-3 text-sm tablet:text-lg md:text-xl text-white nav-text`}
                  >Guías</p>
                )}
              </li>
            </Link>
            <Divider
              sx={{
                bgcolor: '#fff',
                marginY: 2,
                marginX: 2
              }}
            />
            <button
              key='Demo2'
              onClick={() => setCalendlyModalOpen(true)}
              className='flex md:py-2 lg:py-3 px-2 mb-1 border-r-4 border-transparent hover:border-white w-full text-left'
              style={{ display: !sidebarCollapsed ? 'flex' : 'block' }}
            >
              <li ref={addToRef} className="flex">
                <CalendarMonthOutlinedIcon sx={{ color: '#fff', fontSize: '1.25rem', '@media (min-width: 768px)': { fontSize: '1.5rem' }, '@media (min-width: 1200px)': { fontSize: '1.75rem' } }} />
                {sidebarCollapsed && (
                  <p className="ml-3 text-sm tablet:text-lg md:text-xl text-white nav-text">Solicitar demo</p>
                )}
              </li>
            </button>
            <a
              key='Soporte2'
              href='mailto:soporte@muycoach.com'
              className='flex py-1 tablet:py-3 md:py-2 lg:py-3 px-2 mb-1 border-r-4 border-transparent hover:border-white'
              style={{ display: !sidebarCollapsed ? 'flex' : 'block' }}
            >
              <li ref={addToRef} className="flex">
                <InfoOutlinedIcon sx={{ color: '#fff', fontSize: '1.25rem', '@media (min-width: 768px)': { fontSize: '1.5rem' }, '@media (min-width: 1200px)': { fontSize: '1.75rem' } }} />
                {sidebarCollapsed && (
                  <p className="ml-3 text-sm tablet:text-lg md:text-xl text-white nav-text">Soporte</p>
                )}
              </li>
            </a>
            <div
              className="flex flex-row px-2 mt-4"
              style={{ justifyContent: sidebarCollapsed ? "end" : "center" }}
            >
              <button
                type="button"
                onClick={() => {
                  if (!isDesktop && setSidebarOpen) {
                    setSidebarOpen(false);
                  } else {
                    setSidebarCollapsed(!sidebarCollapsed);
                  }
                }}
                className={`mt-2 ${sidebarCollapsed && 'mr-2'} bg-transparent hover:bg-gray-100 rounded-lg`}
              >
                <img
                  src={(sidebarCollapsed ? arrowLeft : arrowRight)}
                  alt=""
                  className="w-7 h-auto text-gray-500 transition duration-75"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      <CalendlyModal open={calendlyModalOpen} setOpen={setCalendlyModalOpen} />
    </aside>
  )
}

export default Sidebar;
